import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import {Card, CardContent} from "@mui/material";
import {useRecommendedContext} from "../../../context/recommended/RecommendedContext";
import {mutate} from "swr";
import {deleteData} from "../../../lib/dashboard/actions";
import {COLORS} from "../../../ui/Theme";
import Loading from "../../../components/loader/Loading";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    outline: "none",
};

const RecommendedDeleteMessage = ({
                                      openDeleteModal,
                                      handleDeleteModalClose,
                                  }) => {
    const {config, currentConfig} = useRecommendedContext();

    //DELETE SETTING NAME
    const handleDeleteConfig = async (id) => {
        const res = await deleteData(`/stock-market/recomm-config-new/${id}`);
        if (res.status === 200) {
            await mutate("/stock-market/v2/recomm-config");
            handleDeleteModalClose();
        }
    };

    return (
        <Modal open={openDeleteModal} onClose={handleDeleteModalClose}>
            <Card sx={style}>
                <CardContent
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                        textAlign: "center",
                        gap: "15px",
                    }}
                >
                    <Typography sx={{fontSize: "16px", fontWeight: "bold"}}>
                        آیا مطمئن هستید؟
                    </Typography>
                    <Typography sx={{fontSize: "14px"}}>
                        در صورت پاک کردن تنظیمات دیگر قابل بازگشت نمی باشند
                    </Typography>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "15px",
                        }}
                    >
                        <button
                            disabled={config.isValidating}
                            onClick={() => handleDeleteConfig(currentConfig?.id)}
                            className="btn btn-red"
                            style={{justifyContent: "center"}}
                        >
                            {config.isValidating ? (
                                <Loading
                                    size="11px"
                                    color={COLORS.WHITE}
                                />
                            ) : (
                                "حذف تنظیمات"
                            )}
                        </button>
                        <button
                            onClick={handleDeleteModalClose}
                            className="btn btn-softblue"
                            style={{justifyContent: "center"}}
                        >
                            بازگشت
                        </button>
                    </Box>
                </CardContent>
            </Card>
        </Modal>
    );
};

export default RecommendedDeleteMessage;
